import { google, outlook, office365, yahoo, ics } from "./../../../../../../../node_modules/calendar-link/dist/index.modern";
import { decode } from "./../../../../../../../node_modules/js-base64/base64.mjs";

document.addEventListener( "DOMContentLoaded", () => {
	const elements = document.querySelectorAll( ".add-to-calendar" );

	/**
	 * Package "calendar-link" exports initial variable names instead renamed ones.
	 * For example, it should export according to code, "y as google" but it does not do that.
	 * It rather exports straight up "y".
	 * This function is simple workaround that glitch.
	 * @param {string} calendarName The name of the calendar.
	 * @returns {string} Calendar name to be used.
	 */
	function renameCalendar( calendarName ) {
		switch ( calendarName ) {
			case "y":
				return "google";
			case "v":
				return "iCalendar";
			case "$":
				return "office365";
			case "m":
				return "outlook";
			case "g":
				return "yahoo";
		}
	}

	elements.forEach( element => {
		const button = element.querySelector( ".add-to-calendar__button" );
		const anchorWrapper = element.querySelector( ".add-to-calendar__links" );
		const dataRaw = decode( element.dataset.event );
		const data = JSON.parse( dataRaw );
		const calendars = [ google, outlook, office365, yahoo, ics ];

		// Do the links.
		calendars.forEach( calendar => {
			const a = document.createElement( "a" );
			a.href = calendar( data );
			a.target = "_blank";
			a.innerText = renameCalendar( calendar.name );
			a.classList.add( renameCalendar( calendar.name ) );
			anchorWrapper.appendChild( a );
		} );

		// Do the click.
		document.addEventListener( "click", event => {
			event.stopPropagation();

			switch ( event.target ) {
				case button:
					anchorWrapper.classList.toggle( "visible" );
					break;
				case anchorWrapper:
					break;
				default:
					anchorWrapper.classList.remove( "visible" );
					break;
			}
		} );
	} );
} );
